import React, { Component } from 'react';
import { connect } from 'react-redux';
import subPage from '../decorators/subPage';
import { portInfo } from '../actions/subs';
import { getAllPortInfo } from '../reducers';
import PortInfo from '../components/PortInfo';
import SubNav from '../components/SubNav';

export class ViewPortInfo extends Component {
  componentDidMount() {
    this.fetchPortInfo();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.subId !== this.props.subId) {
      this.fetchPortInfo();
    }
  }

  fetchPortInfo() {
    const { portInfo, subId } = this.props;
    portInfo(subId);
  }

  render() {
    const { port } = this.props;

    if (!port) {
      return <div>Loading...</div>;
    }

    return (
      <div>
        <h1>Port Info</h1>
        <div>
          <SubNav />
        </div>
        <br />
        <h4>Current</h4>
        {port['current'] && <PortInfo data={port['current']} />}
        <br />
        <h4>Previous</h4>
        {port['previous'].map((data, i) => (
          <div key={i}>
            <PortInfo data={data} />
            <hr />
          </div>
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state, { subId }) => ({
  port: getAllPortInfo(state, subId),
});

const mapDispatchToProps = {
  portInfo,
};

export const ConnectedViewPortInfo = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewPortInfo);

const WrappedViewPortInfo = subPage(ConnectedViewPortInfo);

export default WrappedViewPortInfo;
